import { useData } from 'components/common-form/hooks/useData';
import { CorrelationTableNext, CorrelationTableProps } from 'components/shared/Correlation/CorrelationTableNext';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export function CorrelationTableField({ node: { id } }: ProductNodeBuilderProps) {
  const [value] = useData<CorrelationTableProps>(id);

  return (
    <div className="w-100">
      <CorrelationTableNext correlationsNext={value?.correlationsNext ?? []} />
    </div>
  );
}

CorrelationTableField.displayName = 'CorrelationTableField';
